import axios, { AxiosResponse } from 'axios';
import { Auth } from '../routes/login/auth'
import { BusinessUser, BusinessAccount } from './types';

export const login = (api: string, username: string, password: string) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios
    .post(`${api}/api/auth-business-users`, { username, password }, { headers });
};

export const refresh = (api: string, refreshToken: string) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios
    .post(`${api}/api/auth-business-users/refresh`, { refreshToken }, { headers });
};

export const getBusinessUser = async (api: string): Promise<BusinessUser | undefined> => {
  const headers = {
    'authorization': `Bearer ${Auth.getAccessToken()}`,
    'Content-Type': 'application/json',
  };
  
  try {
    const meResponse: AxiosResponse<{ businessUser: BusinessUser }> =
      await axios.get(`${api}/v1/private/me`, { headers });
    return meResponse.data.businessUser;
  } catch (err) {
    if (err.response) {
      Auth.resetTokenIfUnauthorized(err.response);
    }
    return undefined;
  }
};

export const getBusinessUserAccountNames = async (api: string, businessUserId: string): Promise<string[] | undefined> => {
  const headers = {
    'authorization': `Bearer ${Auth.getAccessToken()}`,
    'Content-Type': 'application/json',
  };
  try {
    const businessAccountsResponse: AxiosResponse<{ businessAccounts: BusinessAccount[] }> =
      await axios.get(`${api}/v1/private/business-accounts?businessUserId=${businessUserId}`, { headers });

    return businessAccountsResponse.data.businessAccounts
      ? businessAccountsResponse.data.businessAccounts.map(businessAccount => businessAccount.name)
      : [];
  } catch (err) {
    if (err.response) {
      Auth.resetTokenIfUnauthorized(err.response);
    }
    return undefined;
  }
}
